/** 菜单 */
export default {
    home: "home",
    systemMonitoring: "system monitoring", // 系统监控
    systemTools: "system tools", // 系统工具
    platformManage: "platform manage", // 平台管理
    workbench: "workbench", // 工作台
    organization: "organization", // 组织架构
    entityManage: "entity manage", // 实体管理
    enterpriseEquipment: "enterprise equipment", // 企业设备
    systemManage: "system manage", // 系统管理
        region: "region", // 行政区域
        userManage: "account manage", // 用户管理
        roleManage: "role manage", // 角色管理
        deptManage: "dept manage", // 部门管理
        postManage: "post manage", // 岗位管理
        dictManage: "dict manage", // 字典管理
        counterManage: "counter manage", // 计数器管理
        notice: "notice", // 通知公告
        i18nConfig: "i18n config", // 国际化配置
    financeManage: "financial manage", // 财务管理
        applicationInfo: "application info", // 引用信息
        merchantInfo: "merchant info", // 商户信息
        payChannel: "pay channel", // 支付渠道
        payPackage: "pay package", // 支付套餐
        payNotice: "pay notice", // 支付通知
        merchantNotice: "merchant notice", // 商户通知
        payOrder: "pay order", // 支付订单
        payOrderExtend: "pay orderExtend", // 支付订单扩展
        refundOrder: "refund order", // 退款订单
    dataCorrection: "data correction", // 数据修正
        equipmentData: "equipment data", // 设备传输数据
        minuteDimension: "minute dimension", // 五分钟维度
        hourDimension: "hour dimension", // 小时维度
        hourShadowDimension: "hour shadow dimension", // 小时影子维度
        dayDimension: "day dimension", // 天维度
    passengerFlow: "passenger flow", // 客流管理
        screenSetting: "screen setting", // 大屏设置
        passagewayManage: "passageway manage", // 出入口管理
        faceCaptureData: "face capture data", // 人脸抓拍数据
    logManage: "log manage", // 日志管理
        operateLog: "operate log", // 操作日志
        loginLog: 'login log', // 登录日志
    developerCentre: "developer centre", // 开发者
}